export const AVERAGE_AGE_GROUP_YEARS = 25
